import { PageModuleType } from '@/types/module.types';
import { BrandliveEvent } from '@/types/projects.types';
import { Session } from '@/types/session.types';
import { LanguagesAbbr } from '@/types/translation.types';
import convertHtmlString from '@/utils/convert-html-string';
import FolderPaths from '@/utils/images';

const firstSessionByTimestamp = (event: BrandliveEvent): Session | undefined => {
  return [...event.sessions].sort((a, b) => (a.timestamp || 0) - (b.timestamp || Infinity))[0];
};

export const projectNameAndDescription = (
  event: BrandliveEvent,
  language: LanguagesAbbr,
  forEmailType?: 'google' | 'others'
): { name: string; description: string; image: string } => {
  const firstSession = firstSessionByTimestamp(event);
  const mainBanner =
    event.homepage && event.homepage.modules.find((module) => module.type === PageModuleType.main_event_banner);
  const name =
    mainBanner?.content?.title?.[language] ??
    event.registration_settings?.title?.[language] ??
    event.registration_settings?.title?.base ??
    '';
  const descriptionModule = firstSession?.modules.find((module) => module.type === PageModuleType.description);
  const description = (descriptionModule?.content?.description?.[language] ??
    descriptionModule?.content?.description?.base ??
    '') as string;
  const image =
    firstSession?.pre_broadcast_thumbnail ??
    firstSession?.post_broadcast_thumbnail ??
    firstSession?.image ??
    (FolderPaths.LimelightBanner as string);

  if (forEmailType === 'google') {
    const descriptionText = convertHtmlString(description, '<p><br></p>');
    return { name: convertHtmlString(name), description: descriptionText, image };
  } else if (forEmailType === 'others') {
    const descriptionText = convertHtmlString(description, '\\n\\n');
    return { name: convertHtmlString(name), description: descriptionText, image };
  } else {
    return { name: convertHtmlString(name), description: convertHtmlString(description), image };
  }
};
